jQuery_T4NT(document).ready(function($) {
if ($(window).width() > 767){
  $('.other-products').appendTo('.t4s-product__media-wrapper');
}
if ($('.t4s-product-form__buttons .t4s-pr-wishlist').hasClass("is--added")) {
   $('.pr-wishlist ').toggleClass('active');
   if ($('.pr-wishlist .t4s-text-pr').text() == "Add to Wishlist")
       $('.pr-wishlist .t4s-text-pr').text("Remove Wishlist")
    else
       $('.pr-wishlist .t4s-text-pr').text("Add to Wishlist");
}
  
  $('.t4s-product-form__buttons .t4s-pr-wishlist').click(function(){
        $('.pr-wishlist ').toggleClass('active');
   if ($('.pr-wishlist .t4s-text-pr').text() == "Add to Wishlist")
       $('.pr-wishlist .t4s-text-pr').text("Remove Wishlist")
    else
       $('.pr-wishlist .t4s-text-pr').text("Add to Wishlist");

   
  });
  $('.pr-wishlist').click(function(event){
   event.preventDefault()
$('.t4s-form__product .t4s-pr-wishlist').click();
      $(this).toggleClass('active');
   if ($('.pr-wishlist .t4s-text-pr').text() == "Add to Wishlist")
       $('.pr-wishlist .t4s-text-pr').text("Remove Wishlist")
    else
       $('.pr-wishlist .t4s-text-pr').text("Add to Wishlist");
});

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});